import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function ConfigurationCategory() {
    return (
        <ConfigurationMaster
            type="category"
        />
    );
}

export default ConfigurationCategory;